import { createFileRoute } from '@tanstack/react-router'
import { CostDashboard } from 'pages/costDashboard/CostDashboard'
import { costDashboardSearchSchema } from 'pages/costDashboard/searchSchema'

export const Route = createFileRoute('/cost-dashboard')({
  component: CostDashboard,
  validateSearch: costDashboardSearchSchema,
  staticData: {
    title: 'Cost Dashboard',
    layout: {
      showNavbar: true,
      showSearchBar: false,
      enforceMaxWidth: false,
      enableScrolling: true,
    },
  },
})
